import React from 'react';
import './LoadingSpinner.scss';
export function LoadingSpinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center h-64"
  }, /*#__PURE__*/React.createElement("span", {
    className: "loader-spin"
  }));
}